import api from './api';

export const siteSettingsService = {
  get: async () => {
    const res = await api.get('/SiteSettings/Get');
    return res.data.data;
  },

  updateListingDuration: async (days) => {
    const res = await api.put('/SiteSettings/UpdateListingDuration', { listingDurationDays: days });
    return res.data.data;
  },
};
